// extracted by mini-css-extract-plugin
module.exports = {"modal":"AccreditationModal_modal__-Z_3t","modal_modal":"AccreditationModal_modal_modal__1lYeU"};